import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useItemActor } from '../../../../hooks/useItemActor';

export const ActorItemContext = React.createContext();

const  ActorItemProvider = ({children}) =>{
  const actorActions  = useItemActor("parties")
  const CountryList=useSelector((state) => state.DropDownValues.countryTypes);
  const representations=useSelector((state) => state.DropDownValues.Representations);

  const actions=useMemo(()=>(
    {CountryList,representations,...actorActions
    }),
    [CountryList,representations,actorActions])
    
  return (
    <ActorItemContext.Provider value={actions}>
       {children}
    </ActorItemContext.Provider>
  )
}

export default ActorItemProvider